<!--
* @Description:相关调研1
* @Date: 2024-01-19 09:33:01
-->
<template>
  <div
    class="patient-sex"
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="content" ref="ContentRef">
      <div class="content-tip">
        <div class="content-tip-box">
          <div
            class="content-tip-item"
            v-for="(item, index) in _data.tipData"
            :key="index"
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
          >
            <div
              class="content-tip-top"
              :style="{ marginTop: (index + 1) / 2 != 0 ? '3px' : '0px' }"
            >
              <div class="content-tip-top-bg"></div>
              <div class="content-tip-top-text">
                <div>
                  <div v-for="(item2, index2) in item" :key="index2">
                    {{ item2.label }}:{{ item2.value }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              style="padding: 5px 10px; line-height: 16px"
              :style="{ marginTop: index % 2 ? '3px' : '0px' }"
            >
              <div>
                <div>{{ _data.projectName[index]?.value }}</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="content-name">
        <div>
          <div
            :style="{ '--color': `var(--theme-color-${index + 1},#000)` }"
            v-for="(item, index) in _data.projectName"
            :key="index"
          >
            <div></div>
            <div>{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { selfAdaption, useDataAssembly } from './hooks';
const props = defineProps<{
  tableHeaderList: Array<{ label: Array<string>; prop: string }>;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();
let _data = useDataAssembly(props.tableHeaderList, props.tableDataList);
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.patient-sex {
  @include patientSex();
  height: 641px;
  .content {
    position: relative;
    @include content();
    height: 641px;
    display: flex;
    flex-direction: column;
    .content-tip {
      position: relative;
      margin-top: 110px;
      display: flex;
      justify-content: center;
      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: black;
        left: 0;
        bottom: 0;
        opacity: 0.3;
      }
      .content-tip-box {
        display: flex;
        position: relative;
        .content-tip-item {
          width: 106px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;

          &::after {
            content: '';
            width: 16px;
            height: 16px;
            border: 2px solid #fff;
            border-radius: 100%;
            background-color: var(--color, #000);
            transform: translateY(50%);
          }
          &::before {
            content: '';
            width: 1px;
            height: 19px;
            background-color: #000;
            position: absolute;
            bottom: 0;
          }
          &:nth-child(odd) {
            flex-direction: column-reverse;
            transform: translateY(99%);
            &::after {
              transform: translateY(-8px);
            }
            &::before {
              content: '';
              width: 1px;
              height: 22px;
              background-color: #000;
              position: absolute;
              top: 0;
            }
          }
          .content-tip-top {
            position: absolute;
            width: 190px;
            height: 117px;
            background: rgba(244, 244, 244, 0.39);
            border-radius: 12px;
            position: relative;
            .content-tip-top-bg {
              opacity: $--opacityText;
              position: absolute;
              width: 190px;
              height: 117px;
              background: var(--color);
              border-radius: 12px;
            }
            .content-tip-top-text {
              position: absolute;
              border: 2px solid var(--color);
              width: 190px;
              height: 117px;
              border-radius: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              > div {
                @include text();
              }
            }
          }
          > div {
            &:nth-child(2) {
              width: 190px;
              height: 52px;
              background: var(--color);
              border-radius: 12px;
              color: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
    .content-name {
      position: absolute;
      bottom: -29px;
      height: 100px;
      width: 100%;
      display: flex;
      justify-content: center;
      > div {
        display: flex;
        width: 80%;
        justify-content: center;

        > div {
          margin: 0 10px;
          display: flex;
          width: 100%;
          > div:nth-child(1) {
            margin-right: 5px;
            width: 21px;
            height: 21px;
            background-color: var(--color);
          }
          > div:nth-child(2) {
            @include bottomText();
          }
        }
      }
    }
  }
}
</style>
